import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Sidebar from './components/Sidebar';
import RecommendationsPage from './pages/RecommendationsPage';
import TopicsPage from './pages/TopicsPage';
import WeeklyDigestPage from './pages/WeeklyDigestPage';
import FavoritesPage from './pages/FavoritesPage';
import SearchPage from './pages/SearchPage';
import ArticlePage from './pages/ArticlePage';
import AgentPage from './pages/AgentPage';
import AboutPage from './pages/AboutPage';

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Sidebar />
          <main className="content">
            <Routes>
              <Route path="/" element={<RecommendationsPage />} />
              <Route path="/topics" element={<TopicsPage />} />
              <Route path="/weekly" element={<WeeklyDigestPage />} />
              <Route path="/starred" element={<FavoritesPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/article/:id" element={<ArticlePage />} />
              <Route path="/agent" element={<AgentPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}
